import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ReasoningService, ReasoningLevel } from '../../../services/reasoning.service';
import { UserPreferencesService } from '../../../services/user-preferences.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-glm',
  templateUrl: './glm.component.html',
  styleUrls: ['./glm.component.scss']
})
export class GlmComponent implements OnInit, OnDestroy {
  modelId = 'zai'; // GLM model ID
  selectedReasoningLevel: ReasoningLevel = 'thinking';
  supportsReasoning = true;
  private reasoningSub?: Subscription;

  constructor(
    private dialogRef: MatDialogRef<GlmComponent>,
    private reasoningService: ReasoningService,
    private preferencesService: UserPreferencesService
  ) {}

  ngOnInit(): void {
    // Check if model supports reasoning
    this.supportsReasoning = this.reasoningService.modelSupportsReasoning(this.modelId);
    
    if (this.supportsReasoning) {
      // Try to load saved preference for this model
      this.preferencesService.getReasoningLevelForModel(this.modelId).then(savedLevel => {
        if (savedLevel) {
          this.selectedReasoningLevel = savedLevel;
          this.reasoningService.setReasoningLevel(savedLevel);
        } else {
          // Use current global reasoning level
          this.selectedReasoningLevel = this.reasoningService.getReasoningLevel();
        }
      });

      // Subscribe to reasoning level changes
      this.reasoningSub = this.reasoningService.reasoningLevel$.subscribe(level => {
        this.selectedReasoningLevel = level;
      });
    }
  }

  ngOnDestroy(): void {
    this.reasoningSub?.unsubscribe();
  }

  onReasoningLevelChange(level: ReasoningLevel): void {
    this.selectedReasoningLevel = level;
    // Save to Firebase preferences (setReasoningLevel will handle it)
    this.reasoningService.setReasoningLevel(level, this.modelId);
  }

  close() {
    this.dialogRef.close();
  }
}
